module.exports = __webpack_public_path__ + "static/back-cover-6861f4cc7940d27e6dc8a60214a4615e.png";